module.exports = __webpack_public_path__ + "static/media/RKBrowser5w1442@2x.c084b3eb.webp";